import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { FiltersComponent } from './filters.component';
import { FilterComponent } from './filter.component';
import { FiltersItemComponent } from './filters-item.component';
import { AuthGuard } from 'src/app/core/providers';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ItemArrowComponent } from '../core/components/item-arrow/item-arrow.component';
import { FiltersService } from './filters.service';
import { MatDivider } from '@angular/material/divider';
import { ReactiveFormsModule } from '@angular/forms';
import { DynamicContainerDirective } from './filter-types/directives/dynamic-container.directive';

@NgModule({
  imports: [
    ReactiveFormsModule,
    RouterModule.forChild([
      {
        path: 'filters',
        component: FiltersComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'filters/:filterId',
        component: FilterComponent,
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
      },
    ]),
    CommonModule,
    CoreModule,
    MatTooltipModule,
    ItemArrowComponent,
    MatDivider,
    DynamicContainerDirective,
  ],
  providers: [FiltersService],
  declarations: [FilterComponent, FiltersComponent, FiltersItemComponent],
})
export class FiltersModule {}
